// extracted by mini-css-extract-plugin
export default {"container":"ThemeSwitcher_container__9wUVn","switcher":"ThemeSwitcher_switcher__Q--gU"};